import React, { useEffect, useState } from "react";
import { Modal, Table, Spin, Alert } from "antd";
import axiosInstance, { endpoints } from "services/axios";

interface ScheduleModalProps {
  id: string;
  visible: boolean;
  onClose: () => void;
}

interface UserData {
  name: string;
  photo: string;
  companyName: string;
}

const ScheduleModal: React.FC<ScheduleModalProps> = ({
  id,
  visible,
  onClose,
}) => {
  const [data, setData] = useState<UserData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (visible && id) {
      fetchData(id);
    }
  }, [visible, id]);

  const fetchData = async (scheduleId: string) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get(
        endpoints.employees.list(scheduleId)
      );
      //   console.log(response.data.data);
      setData(response.data.data);
    } catch (err: any) {
      setError("Failed to fetch employee data");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: <span className="text-primary font-semibold">Photo</span>,
      dataIndex: "photo",
      key: "photo",
      render: (photo: string) => (
        <img
          src={photo}
          alt="User"
          className="w-12 h-12 rounded-full object-cover "
        />
      ),
    },
    {
      title: <span className="text-primary font-semibold">Name</span>,
      dataIndex: "fio",
      key: "fio",
    },
    {
      title: <span className="text-primary font-semibold">Company</span>,
      dataIndex: "company",
      key: "company",
      render: (company: any) => <>{company?.name}</>,
    },
  ];

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={
        <h2 className="text-primary text-lg font-bold">User Work Schedule</h2>
      }
      className="rounded-lg"
    >
      {loading && (
        <div className="flex justify-center py-6 text-primary">
          <Spin size="large" />
        </div>
      )}

      {error && <Alert type="error" message={error} className="mb-4" />}

      {!loading && !error && (
        <Table
          dataSource={data}
          columns={columns}
          rowKey={(record) => record.name + record.companyName}
          pagination={false}
        />
      )}
    </Modal>
  );
};

export default ScheduleModal;
